import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { IConsumersWalletCampaignListModuleModel } from '@models/Consumers';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

export enum EnumTypeCampaign {
    DEFAULT = 1,
    WITH_EXPIRED_DATE = 2, // com validade de data
    WITHOUT_EXPIRED_DATE = 3 // data - vitalicio
}
@Component({
    selector: 'app-configure-module',
    templateUrl: './configure-module.component.html',
    styleUrls: ['./configure-module.component.scss'],
})
export class ConfigureModuleModalComponent implements OnInit {

    private static readonly MAX_END_DATE_YEAR: number = 9999;

    public Form: FormGroup;
    public HeaderTitle: string = '';
    public Data: any;
    private modules: any[] = [];
    private showToast: Function;
    private onSaveConfiguration: Function;

    public EnumTypeCampaign = EnumTypeCampaign;

    public MaxDate: string;

    /**
     * 
     */
    public get Modules(): FormArray {
        return this.Form?.get('Modules') as FormArray ?? new FormArray([]);
    }

    private BuildDateForYear(year: number): string {

        const date = new Date();

        date.setFullYear(year);

        return date.toISOString();
    }


    constructor(private ModalController: ModalController,
        private NavParams: NavParams) {

        this.HeaderTitle = this.NavParams.get('title');
        this.modules = this.NavParams.get('modules') || [];
        this.showToast = this.NavParams.get('showToast') || null;
        this.onSaveConfiguration = this.NavParams.get('onSaveConfiguration') || null;

        // console.table(this.modules);

        this.MaxDate = this.BuildDateForYear(ConfigureModuleModalComponent.MAX_END_DATE_YEAR);

        const configureModule = this.NavParams.get('configureModule') || {};
        const maxEndDateYearsFromNow = configureModule?.MaxEndDateYearsFromNow;

        // se o projeto não configurar MaxEndDateYearsFromNow, prevalece a janela própria de cada campanha (CampaignConfigValidationDays); caso contrário, prevalece a configuração do projeto
        const projectMaxDate = maxEndDateYearsFromNow != null
            ? this.BuildDateForYear(Math.min(new Date().getFullYear() + Number(maxEndDateYearsFromNow), ConfigureModuleModalComponent.MAX_END_DATE_YEAR))
            : null;

        this.Form = new FormGroup({
            Modules: new FormArray([])
        });

        const fmodules: FormArray = this.Form.get('Modules') as FormArray;

        this.modules.forEach(el => {

            const fArrayGroup: FormArray = new FormArray([]) as FormArray;

            el?.CampaignList?.forEach(g => {

                let campaignConfigValidationDays = this.MaxDate;

                if (projectMaxDate) {
                    campaignConfigValidationDays = projectMaxDate;
                } else if (g.CampaignConfigValidationDays) {
                    const campaignDate = new Date(g?.CampaignStartDate || null);
                    campaignDate.setDate(campaignDate.getDate() + g.CampaignConfigValidationDays);
                    campaignConfigValidationDays = campaignDate.toISOString();
                }

                fArrayGroup.push(
                    new FormGroup({
                        Id: new FormControl(g?.Campaign?.Id),
                        Name: new FormControl(g?.Campaign?.Name),
                        Checked: new FormControl(g?.IsUserAssociated ?? false),
                        CampaignConfigValidationDays: new FormControl(campaignConfigValidationDays),
                        CampaignStartDate: new FormControl(g?.CampaignStartDate ? new Date(g?.CampaignStartDate).toISOString() : null),
                        StartDate: new FormControl(g?.UserCardStartDate ? new Date(g?.UserCardStartDate).toISOString() : null),
                        EndDate: new FormControl(g?.UserCardEndDate ? new Date(g?.UserCardEndDate).toISOString() : null),
                        Type: new FormControl(Number(g?.Type?.Id))
                    })
                )
            });

            fmodules.push(new FormGroup({
                Id: new FormControl(el?.Module?.Id),
                Name: new FormControl(el?.Module?.Name),
                Checked: new FormControl(el?.IsUserAssociated),
                Groups: fArrayGroup
            }))


        })

        this.Form.valueChanges.subscribe(value => {
            console.log(value);

        })

    }

    ngOnInit() { }

    /**
     * 
     * @param ev 
     */
    Close(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }


    /**
     * 
     * @param index 
     * @returns 
     */
    public GetArrayControls(index: number): FormArray {

        return this.Modules.at(index).get('Groups') as FormArray;
    }

    /**
     * 
     * @param index 
     * @param gIndex 
     * @returns 
     */
    public GetGroupControls(index: number, gIndex: number): FormGroup {

        return (this.Modules.at(index).get('Groups') as FormArray).at(gIndex) as FormGroup;

    }

    public async OnSave(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (!this.Form.dirty) return this.showToast('Não foram encontradas alterações.');

        this.Form.markAllAsTouched();

        if (!this.Form.valid) {

            return this.showToast('Preencha todos os campos assinalados.');
        }

        const moduleList: IConsumersWalletCampaignListModuleModel[] = [];


        this.Form.get('Modules').value.forEach(module => {

            moduleList.push({
                IsUserAssociated: module?.Checked,
                Module: {
                    Id: module?.Id,
                    Name: module?.Name
                },
                CampaignList: module?.Groups?.map(it => {
                    return {
                        Campaign: {
                            Id: it.Id,
                            // Name: it.Name
                        },
                        // Type: { Id: it.Type },
                        // CampaignStartDate: it?.CampaignStartDate || null,
                        UserCardStartDate: it?.StartDate || null,
                        UserCardEndDate: it?.EndDate || null,
                        IsUserAssociated: it?.Checked ?? null
                    }
                }) || []
            });


        });



        if (this.onSaveConfiguration) {
            const response = await this.onSaveConfiguration(moduleList);

            console.log(response);
            if (response) this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);

        }
    }
}
